const ITEMS = [
  "Confection Drôme — Point par Point",
  "Broderie Isère — Brod'Art",
  "Burlington Oeko Tex 110 g/m²",
  "Ne retient pas les cheveux",
  "Fait main en France",
  "Paiement en 2 fois sur demande",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-10 font-serif text-2xl sm:text-3xl italic text-[#B0ABA0] whitespace-nowrap">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/70" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#E2DBCB]/10 bg-[#0C0D0E] py-8"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
